import { render } from "./RecordPage.vue?vue&type=template&id=ddff9282&scoped=true"
import script from "./RecordPage.vue?vue&type=script&lang=js"
export * from "./RecordPage.vue?vue&type=script&lang=js"

import "./RecordPage.vue?vue&type=style&index=0&id=ddff9282&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddff9282"]])

export default __exports__